import { useState, useCallback } from "react";
import { getFilteredNotesByKeywordsURL } from "../utils/ConstantsURL";

export const useGetFilteredNotes = (token) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchNotas = useCallback(async (filters, isNewSearch = false, currentCursor = null) => {
    setLoading(true);
    setError(null);

    const body = { ...filters, paginationMode: "all" };
    // PAGINACIÓN COMENTADA: se envía paginationMode "all" para que el backend
    // devuelva todas las notas y no aplique el límite por defecto (100).
    // if (!isNewSearch && currentCursor?.cursorDate && currentCursor?.cursorId) {
    //   Object.assign(body, currentCursor);
    // }

    try {
      const response = await fetch(getFilteredNotesByKeywordsURL(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.errors?.[0]?.message ||
            errorData.message ||
            "Ocurrió un error al obtener las notas."
        );
      }

      const data = await response.json();

      return {
        notes: data.notes || [],
        keyword: data.keyword || "",
        totalNotes: data.data ?? 0,
        totalMedia: data.totalMedia ?? 0,
        nextCursor: data.nextCursor || null,
        isNewSearch,
      };
    } catch (error) {
      setError(error);
      throw error;
    } finally {
      setLoading(false);
    }
  }, [token]);

  return { loading, error, fetchNotas };
};
